import { ApiPage } from "@/api/page";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";
import { useMemo } from "react";

export const useAddressesData = (query: string) => {
  const { data: addresses, isLoading } = useLocalizedQuery({
    queryKey: ["addresses"],
    queryFn: async lang => ApiPage.getAddressesPage(lang),
  });

  const filteredAddresses = useMemo(() => {
    if (!addresses) return [];

    return addresses.filter(address => {
      const searchStringByAddress = address.address.toLowerCase();
      const searchStringByTitle = address.title.toLowerCase();
      const lowerQuery = query.toLowerCase();

      return searchStringByAddress.includes(lowerQuery) || searchStringByTitle.includes(lowerQuery);
    });
  }, [addresses, query]);

  return { addresses: filteredAddresses, isLoading };
};
